import React from "react";

const ReactionPills = ({ reactions = [], messageId, currentUserId, socket }) => {
    // Group reactions by emoji
    const grouped = reactions.reduce((acc, r) => {
        if (!acc[r.emoji]) {
            acc[r.emoji] = { count: 0, users: [] };
        }
        acc[r.emoji].count++;
        acc[r.emoji].users.push(r.userId?._id || r.userId);
        return acc;
    }, {});

    const toggleReaction = (emoji) => {
        if (socket) {
            socket.emit("add_reaction", { messageId, emoji });
        }
    };

    if (Object.keys(grouped).length === 0) {
        return null;
    }

    return (
        <div className="absolute -bottom-2 right-2 flex gap-1 z-10">
            {Object.entries(grouped).map(([emoji, data]) => {
                const isActive = data.users.includes(currentUserId);
                return (
                    <div
                        key={emoji}
                        onClick={() => toggleReaction(emoji)}
                        className={`
              bg-white/80 backdrop-blur-sm border border-zinc-100 shadow-sm 
              rounded-full px-2 py-0.5 text-xs flex items-center gap-1 
              cursor-pointer hover:bg-white transition-all select-none
              ${isActive ? "ring-1 ring-indigo-500/30 bg-indigo-50" : ""}
            `}
                        title={`${data.count} reaction${data.count > 1 ? "s" : ""}`}
                    >
                        <span>{emoji}</span>
                        <span className="text-zinc-600 font-medium">{data.count}</span>
                    </div>
                );
            })}
        </div>
    );
};

export default ReactionPills;
